import React, { PropTypes } from 'react';

import LoadingSpinner from '../../../shared/js/components/LoadingSpinner';

import { sortBy } from 'lodash';
import { propertyHasChanged } from '../lib/objectComparison';

import '../../styles/SelectGlobalThing';

class SelectGlobalClassroom extends React.Component {

	componentWillMount() {
		if (this.props.selectedSchool) {
			// If there is already a list of classrooms in props, and a school is selected, and the classrooms belong to
			// the selected school, don't re-fetch
			const shouldFetch = !this.props.classrooms ||
				!this.props.classrooms.length ||
				this.props.classrooms[0].school_id !== this.props.selectedSchool.id;

			if (shouldFetch) {
				this.fetchClassrooms(this.props.selectedSchool.id);
			}
		}
	}

	componentDidMount() {
		this.initializeDropdown();
	}

	componentWillReceiveProps(newProps) {
		// After a new school is selected, fetch the associated classrooms
		if (newProps.selectedSchool && propertyHasChanged(newProps.selectedSchool, this.props.selectedSchool)) {
			this.fetchClassrooms(newProps.selectedSchool.id);
			this.props.selectStudent(null);
		}
	}

	componentDidUpdate() {
		// Re-initialize the dropdown to update the list of available classrooms
		this.initializeDropdown();
	}

	fetchClassrooms(schoolId) {
		this.props.fetchClassroomsBySchool(schoolId)
			.then(() => {
				// If a selected classroom ID was stored in local storage, select it in app state
				const selectedClassroomId = localStorage.getItem('classroom');

				if (selectedClassroomId) {
					this.selectClassroomById(selectedClassroomId);
				}
			});
	}

	initializeDropdown() {
		$('.select-global-thing.select-global-classroom .ui.dropdown').dropdown({
			action: 'hide',
			onChange: this.selectClassroomById.bind(this),
			placeholder: 'Select classroom'
		});

		if (this.props.selectedClassroom) {
			$('.select-global-classroom .ui.dropdown').dropdown('set selected', this.props.selectedClassroom.id);
		} else {
			$('.select-global-classroom .ui.dropdown').dropdown('clear');
		}
	}

	selectClassroomById(classroomId) {
		let selectedClassroom;

		if (this.props.classrooms && this.props.selectedSchool) {
			this.props.classrooms.every((classroom) => {
				if (classroom.school_id !== this.props.selectedSchool.id) {
					// Don't allow selection of a classroom that isn't in the selected school.  This would happen if the classroom ID
					// stored in localStorage did not belong to the selected school.  In that case, we can just abort and not select
					// a classroom

					return false;
				} else if (classroom.id.toString() === classroomId.toString()) {
					selectedClassroom = classroom;
					this.props.selectClassroom(classroom);

					return false;
				} else {
					return true;
				}
			});
		}
	}

	isDisabled() {
		return this.props.isFetchingClassrooms ||
			this.props.isFetchingDistricts ||
			this.props.isFetchingSchools ||
			this.props.disabled;
	}

	render() {
		return (
			<div className="select-global-thing select-global-classroom">
				<div className={ `ui floating dropdown labeled search icon button fluid${ this.isDisabled() ? ' disabled' : '' }` }>
					<i />
					<div className="icon-left">C</div>
					<div className="default text">Select classroom</div>
					<div className="menu">
						{
							this.props.selectedSchool && this.props.classrooms ? (
								sortBy(this.props.classrooms, 'description').map((classroom) => {
									return (
										<div
											className="item"
											data-value={ classroom.id }
											key={ `select-global-classroom-option-${ classroom.id }` }
										>
											{ classroom.description }
										</div>
									);
								})
							) : ''
						}
					</div>
					<div className="icon-right">
						{
							this.props.isFetchingClassrooms || this.props.isFetchingSchools || this.props.isFetchingDistricts ? (
								<LoadingSpinner />
							) : (
								<i className="fas fa-caret-down" />
							)
						}
					</div>
				</div>
			</div>
		);
	}
}

SelectGlobalClassroom.propTypes = {
	classrooms: PropTypes.array,
	disabled: PropTypes.bool,
	fetchClassroomsBySchool: PropTypes.func.isRequired,
	isFetchingClassrooms: PropTypes.bool,
	isFetchingDistricts: PropTypes.bool,
	isFetchingSchools: PropTypes.bool,
	selectClassroom: PropTypes.func.isRequired,
	selectedClassroom: PropTypes.object,
	selectedSchool: PropTypes.object,
	selectStudent: PropTypes.func
};

SelectGlobalClassroom.displayName = 'SelectGlobalClassroom';

export default SelectGlobalClassroom;



// WEBPACK FOOTER //
// ./frontend/a2i/js/components/SelectGlobalClassroom.jsx